import { graphql } from 'gatsby';
import React, { FC, ReactElement } from 'react';
import { SiteSiteMetadata, ConfigYamlSlogans } from '../../../gatsby-types';
import { Footer } from '../../layout/Footer';
import { Nav } from '../../layout/Nav';

type Props = Readonly<{
  data: {
    site: {
      siteMetadata: SiteSiteMetadata;
    }
    allConfigYaml: {
      edges: [
        {
          node: {
            slogans: ConfigYamlSlogans;
          }
        }
      ]
    }
  }
}>;

const Dinosaur: FC<Props> = ({ data }): ReactElement => {
  return (
    <div>
      <Nav title={data.site.siteMetadata.title} />
      <iframe src='https://dinosaur-game.netlify.app/' width='984' height='234' />
      <Footer slogans={data.allConfigYaml.edges[0].node.slogans} />
    </div>
  );
};

export default Dinosaur;

export const pageQuery = graphql`
  query Title {
    site {
      siteMetadata {
        title
      }
    }
    allConfigYaml {
      edges {
        node {
          slogans {
            ja
            en
            fr
            es
            zh
          }
        }
      }
    }
  }
`;
